import { Currency } from './types';

export const currencies: Currency[] = [
  {
    code: 'USD',
    label: '$ - US Dollar',
  },
  {
    code: 'CAD',
    label: 'CA$ - Canadian Dollar',
  },
  {
    code: 'AUD',
    label: 'A$ - Australian Dollar',
  },
  {
    code: 'MXN',
    label: 'MX$ - Mexican Peso',
  },
  {
    code: 'EUR',
    label: '€ - Euro',
  },
  {
    code: 'DKK',
    label: 'DKK - Danish Krone',
  },
  {
    code: 'NOK',
    label: 'NOK - Norwegian Krone',
  },
  {
    code: 'SEK',
    label: 'SEK - Swedish Krona',
  },
  {
    code: 'GBP',
    label: '£ - Pound Sterling',
  },
  {
    code: 'BRL',
    label: 'BRL - Brazilian Real',
  },
  {
    code: 'CHF',
    label: 'CHF - Swiss Franc',
  },
  {
    code: 'JPY',
    label: '¥ - Yen',
  },
  {
    code: 'NZD',
    label: 'NZD - New Zealand Dollar',
  },
];
